import { AxiosRequestConfig } from 'axios';

import { IProject } from './modules/Projects/models';

export interface IProjectListView {
    id: number;
    type: string;
    name: string;
    img: string;
}

export interface IHttpClient {
    get: <Response> (url: string, configs: AxiosRequestConfig) => Promise<Response>
    post: <Response, Request> (url: string, data: Request, configs: AxiosRequestConfig) => Promise<Response>;
    put: <Response, Request> (url: string, data: Request, configs: AxiosRequestConfig) => Promise<Response>;
    delete: <Response>(url: string, configs: AxiosRequestConfig) => Promise<Response>;
}

export type Maybe<T> = T | null;

export interface IError {    /** Error code. */
    message?: string;
}

export enum EProcessStatus {
    /** Request canceled. */
    CANCELED = 'CANCELED',
    /** Request fall via errors. */
    ERROR = 'ERROR',
    /** Initial state. */
    IDLE = 'IDLE',
    /** Request pending. */
    PENDING = 'PENDING',
    /** Request resolved successfully. */
    SUCCESS = 'SUCCESS',
}

export interface IData<T> {
    data: T;
}

export interface IAsyncData<T> {
    status: EProcessStatus,
    data: Maybe<T>,
    error: Maybe<T>
}

/**
 * Home Models.
 */
export interface ICategory {
    id: number;
    name: string;
    created_at: string;
    updated_at: string;
}

interface ILink {
    first: string;
    last: string;
    prev: string;
    next: string;
}

interface IMeta {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
}

export interface IProjectList {
    list: IProject[];
    links: ILink;
    meta: IMeta;
}

export interface IProjectFilterResponse {
    data: IProjectFilter[];
}

/**
 * Filter models.
 */
export interface IProjectFilter {
    id: number;
    name: string;
}
